import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  reasonCode: {
    name: "reasonCode",
    label: "Reason Code",
    type: "text",
    errorMsg: "Reason Code is required.",
    required: true,
    editable: false,
    maxLength: 20,
  },
  description1: {
    name: "description1",
    label: "Description 1",
    type: "text",
    maxLength: 100,
  },
  description2: {
    name: "description2",
    label: "Description 2",
    type: "text",
    maxLength: 100,
  },
};

const { reasonCode, description1, description2 } = formField;

export const formRender = [[reasonCode], [description1], [description2]];

export const initialValues = getInitialValues(formField);

export const adjustmentReasonValidation = Yup.object().shape({
  [reasonCode.name]: Yup.string().nullable().max(reasonCode.maxLength).required(reasonCode.errorMsg),
  [description1.name]: Yup.string().nullable().max(description1.maxLength),
  [description2.name]: Yup.string().nullable().max(description2.maxLength),
});
